import { DownloadOutlined } from '@ant-design/icons';
import pluralize from 'pluralize';
import { Button } from 'components/ui';
import { ImportResult } from 'horizon/routes/Inspections/InspectionDetail/InspectionDamageIngestion/types';
import {
  ErrorText,
  SuccessText,
} from 'horizon/components/Assets/CreateAssetsModal/ModalContent/common.style';

type ErrorStateProps = {
  importResult: ImportResult | undefined;
  importedFileName: string;
};

export const ErrorState: React.FunctionComponent<ErrorStateProps> = ({
  importResult,
  importedFileName,
}) => {
  if (importResult?.errorMessage)
    return (
      <>
        <ErrorText fontWeight="bold" mb={2}>
          {importResult.errorMessage}
        </ErrorText>
      </>
    );

  const { createdDamageCount, duplicateDamageCount, invalidDamageCount, invalidDamageCsv } =
    importResult ?? {};

  return (
    <>
      <SuccessText>
        {pluralize('damage', createdDamageCount, true)} successfully created.
      </SuccessText>
      {!!duplicateDamageCount && (
        <>
          <ErrorText fontWeight="bold" mb={2}>
            {pluralize('row', duplicateDamageCount, true)} in {importedFileName} contained duplicate
            damage information.
          </ErrorText>
        </>
      )}
      {!!invalidDamageCount && invalidDamageCsv && (
        <>
          <ErrorText fontWeight="bold" mb={2}>
            {pluralize('row', invalidDamageCount, true)} in {importedFileName} contained invalid or
            incomplete data.
          </ErrorText>
          <ErrorText>
            Please use the button below to download the error file, review and complete faulty or
            missing data and upload again.
          </ErrorText>
          <Button
            icon={<DownloadOutlined />}
            href={invalidDamageCsv}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Error File
          </Button>
        </>
      )}
    </>
  );
};
